import { useState, useEffect } from "react";
import "./CollectionsAll.css";
import { useSelector } from "react-redux";
import { selectCollections, selectUser } from "../../redux/features/appData";
import { Collection } from "winslow-core";
import { CollectionCard } from "./CollectionCard";
import { CollectionCardZero } from "./CollectionCardZero";
import { CollectionQuestionCount } from "../../services/CollectionService.types";
import { apiGetCollectionQuestionCountForUserInWorkspace } from "../../services/CollectionService";

export const CollectionsAll = () => {
  const storeUser = useSelector(selectUser);
  const collections = useSelector(selectCollections);

  const [collectionQuestionCounts, setCollectionQuestionCounts] = useState<
    CollectionQuestionCount[] | null
  >(null);

  useEffect(() => {
    if (storeUser && !collectionQuestionCounts) {
      (async () => {
        if (storeUser.currentWorkspaceId) {
          const cqCount = await apiGetCollectionQuestionCountForUserInWorkspace(
            storeUser.currentWorkspaceId,
            storeUser.id
          );

          setCollectionQuestionCounts(cqCount);
        }
      })();
    }
  }, []);

  return (
    <div id="collections-all">
      <div className="page-title">All Collections</div>
      <div className="collections-grid-container">
        {collections &&
          collections.map((collection: Collection) => {
            return (
              <div
                key={"collection-" + collection.id}
                className="collections-grid-item">
                <CollectionCard
                  key={"collection-card" + collection.id}
                  collection={collection}
                  questionCounts={collectionQuestionCounts}
                />
              </div>
            );
          })}

        <div key={"collection-create"} className="collections-grid-item">
          <CollectionCardZero />
        </div>
        {/* {collections && collections.length === 0 &&
                    <CollectionCardZero />
                } */}
      </div>
    </div>
  );
};
